import { createAction } from '@reduxjs/toolkit';

export const restoreAll = createAction('RESTORE_ALL');
